import { OnInit, Component, ViewChild, ElementRef } from '@angular/core';
import { FilterService } from '../../../../services/filter.service';
import { LogisticsService } from '../../../../services/logistics.service';
import { MenuService } from '../../../../services/menu.service';
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl, FormControl } from '@angular/forms';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { AuthService } from '../../../../services/auth.service';
import { SectorFilter } from '../../../../model/sector-filter';
import { FilterCompleteService } from '../../../../filter-complete/filter-complete';
import { ValidateAutoCompleteSelect } from '../../../../validators/autocomplete-select.validator';
import { BehaviorSubject } from 'rxjs';
import { OrderBatchEditInfo, OrderBatchItem } from '../../../../model/logistics/order';


@Component({
  selector: 'send-individual-order-logistics',
  templateUrl: './send-individual-order-logistics.component.html',
  styleUrls: ['./send-individual-order-logistics.component.css']
})
export class SendIndividualOrderLogisticsComponent implements OnInit {

  loadingAction: boolean;
  loading: boolean;
  form: FormGroup;
  sectors: SectorFilter[];
  filterCompleteSectorSend: FilterCompleteService<SectorFilter>;
  filterCompleteSectorReceiver: FilterCompleteService<SectorFilter>;
  @ViewChild('newProtocol', {static: false}) newProtocol: ElementRef;
  @ViewChild('sectorReceiver', {static: false}) sectorReceiver: ElementRef;
  displayColumns = ['Protocol', 'buttons'];
  dataSource = new BehaviorSubject<AbstractControl[]>([]);

  constructor(private filterService: FilterService
    , private menuService: MenuService
    , private formBuilder: FormBuilder
    , private notificationToastService: NotificationToastService
    , private authService: AuthService
    , private logisticsService: LogisticsService) {
    this.menuService.setMenuTitle('Logística', 'envío individual ordenes');
    this.clear();
    this.filterCompleteSectorSend = new FilterCompleteService<SectorFilter>([], this.fOrderBatch.SectorSend);
    this.filterCompleteSectorReceiver = new FilterCompleteService<SectorFilter>([], this.fOrderBatch.SectorReceiver);
  }

  get filteredSectorReceiverOptions() { return this.filterCompleteSectorReceiver ? this.filterCompleteSectorReceiver.filteredOptions : []; }
  get filteredSectorSendOptions() { return this.filterCompleteSectorSend ? this.filterCompleteSectorSend.filteredOptions : []; }
  get f() { return this.form.controls; }
  get fOrderBatch() { return this.orderBatchForm.controls; }
  get orderBatchForm() { return <FormGroup>this.form.get('OrderBatch'); }
  get orderBatchItemsForm() { return <FormArray>this.form.get('OrderBatchItems'); }

  displayProtocol(index: number): string {
    return this.orderBatchItemsForm.controls[index].value.Protocol;
  }

  onDeleteProtocol(index: number): void {
    this.orderBatchItemsForm.removeAt(index);
    this.dataSource.next(this.orderBatchItemsForm.controls);
  }

  async ngOnInit() {
    try {
      this.loading = true;
      this.sectors = await this.filterService.getSectorsFilter();
      this.filterCompleteSectorSend = new FilterCompleteService<SectorFilter>(this.sectors, this.fOrderBatch.SectorSend);
      this.filterCompleteSectorReceiver = new FilterCompleteService<SectorFilter>(this.sectors, this.fOrderBatch.SectorReceiver);
      const orderBatchEditInfo = await this.logisticsService.getOrderBatchEditInfo(this.authService.getSectorId());
      const sectorSend = this.sectors.find(x => x.Id === orderBatchEditInfo.OrderBatch.SectorSend.Id);

      this.form.patchValue({
         NewProtocol: orderBatchEditInfo.NewProtocol
      });

      this.orderBatchForm.patchValue({
        Description: orderBatchEditInfo.OrderBatch.Description
        , Name: orderBatchEditInfo.OrderBatch.Name
        , CreateDate: orderBatchEditInfo.OrderBatch.CreateDate
        , DeliveryDate: orderBatchEditInfo.OrderBatch.DeliveryDate
        , ReceptionDate: orderBatchEditInfo.OrderBatch.ReceptionDate
        , DeleteDate: orderBatchEditInfo.OrderBatch.DeleteDate
        , UpdateDate: orderBatchEditInfo.OrderBatch.UpdateDate
        , Deleted: orderBatchEditInfo.OrderBatch.Deleted
        , Id: orderBatchEditInfo.OrderBatch.Id
        , BatchStateId: orderBatchEditInfo.OrderBatch.BatchStateId
        , SectorSend: sectorSend
        , SectorReceiver : null
        , CreateUser: orderBatchEditInfo.OrderBatch.CreateUser
        , PlanId: orderBatchEditInfo.OrderBatch.PlanId
        , TaxId: orderBatchEditInfo.OrderBatch.TaxId
        , EntityId: orderBatchEditInfo.OrderBatch.EntityId
        , UpdateUser: orderBatchEditInfo.OrderBatch.UpdateUser
        , DeleteUser: orderBatchEditInfo.OrderBatch.DeleteUser
      });

      setTimeout(() => this.sectorReceiver.nativeElement.focus(), 0);


    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Logística');
    } finally {
      this.loading = false;
    }
  }

  async addProtocol() {
    try {
      if (!this.form.invalid) {
        this.loadingAction = true;
        const items = await
          this.logisticsService.orderBatchItemAddProtocoloIndividualSend(<OrderBatchEditInfo>this.form.getRawValue());
        this.form.controls.OrderBatchItems = this.formBuilder.array([]);
        if (items) {
          items.forEach((item) => this.addOrderBatchItem(item));
        }
        this.form.patchValue({
          NewProtocol: null
        });

      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Logística');
    } finally {
      this.loadingAction = false;
      setTimeout(() => this.newProtocol.nativeElement.focus(), 0);
    }
  }

  async send() {
    try {
      if (this.orderBatchItemsForm.length > 0) {
        this.loadingAction = true;
        if (await this.logisticsService.orderBatchIndividualSend(<OrderBatchEditInfo>this.form.getRawValue())) {
          this.notificationToastService.success('Se han enviado las órdenes correctamente', 'Logística');
          await this.cancel();
        } else {
          this.notificationToastService.error('No se ha podido enviar el lote de órdenes', 'Logística');
        }
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Logística');
    } finally {
      this.loadingAction = false;
    }
  }

  async cancel() {
    this.clear();
    await this.ngOnInit();
  }

  addOrderBatchItem(orderBatchItem: OrderBatchItem): void {

    const row = this.formBuilder.group({
      Protocol: [orderBatchItem.Protocol],
      Id: [orderBatchItem.Id],
      OrderId: [orderBatchItem.OrderId],
      OrdenBatchId: [orderBatchItem.OrdenBatchId],
      Guide: [orderBatchItem.Guide],
    });

    this.orderBatchItemsForm.push(row);
    this.dataSource.next(this.orderBatchItemsForm.controls);
  }

  clear(): void {
    this.form = this.formBuilder.group({
      OrderBatch: this.formBuilder.group({
        Description: [''],
        Deleted: [''],
        EntityId: [''],
        DeliveryDate: [''],
        ReceptionDate: [''],
        Id: [''],
        TaxId: [''],
        BatchStateId: [''],
        Name: [''],
        PlanId: [''],
        SectorSend: new FormControl({ value: '', disabled: true }, [Validators.required, ValidateAutoCompleteSelect]),
        SectorReceiver: ['', [Validators.required, ValidateAutoCompleteSelect]]
      }),
      OrderBatchItems: this.formBuilder.array([]),
      NewProtocol: ['', Validators.required]
    });
  }


}
